import './styles.scss';

import { Icon } from '@ets-global/b2c-website-ui';
import PropTypes from 'prop-types';
import React from 'react';

import CandidateFormikForm from './CandidateFormikForm';

const AddOrUpdateCandidateForm = ({
  candidate,
  order,
  sessionId,
  onComplete,
  onCancel,
  noCandidateAdded,
  productsAndServices,
  withPicture,
  withDateOfBirth,
  testType,
  notEditable = false,
  loading = false,
}) => {
  const addOrUpdate = ({ candidate }, actions) => {
    actions.setSubmitting(false);
    onComplete(candidate);
  };

  return (
    <div className="candidates__candidate">
      {!noCandidateAdded && (
        <button onClick={onCancel} className="candidates__candidate-close" aria-label="cancel candidate close">
          <Icon name={'plus-light'} aria-hidden={'true'} />
        </button>
      )}

      <CandidateFormikForm
        candidate={candidate}
        onSubmit={addOrUpdate}
        order={order}
        notEditable={notEditable}
        productsAndServices={productsAndServices}
        sessionId={sessionId}
        withPicture={withPicture}
        withDateOfBirth={withDateOfBirth}
        loading={loading}
        testType={testType}
      />
    </div>
  );
};

AddOrUpdateCandidateForm.propTypes = {
  candidate: PropTypes.shape({
    token: PropTypes.string,
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    dateOfBirth: PropTypes.string,
    phoneNumber: PropTypes.string,
  }).isRequired,
  order: PropTypes.number.isRequired,
  notEditable: PropTypes.bool,
  sessionId: PropTypes.number.isRequired,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
  noCandidateAdded: PropTypes.bool,
  testType: PropTypes.shape({
    translationKey: PropTypes.string,
  }),
  productsAndServices: PropTypes.shape({
    correctionProductsAndServices: PropTypes.array,
    certificateProductsAndServices: PropTypes.array,
    discountProductsAndServices: PropTypes.array,
  }),
  withPicture: PropTypes.bool,
  withDateOfBirth: PropTypes.bool,
  loading: PropTypes.bool,
};

export default AddOrUpdateCandidateForm;
